import { cn } from '@/lib/core/utils/cn';
import { Step } from './step';
import { RowElementModel } from '@/services/platform/api/model';
import { RowItem, SplashContext } from '@/lib/core/types';

interface StepRowProps {
  row: RowItem;
  index?: number;
  context?: SplashContext;
}

export function StepRow({ row, index: rowIndex, context }: StepRowProps) {
  if (!row.components.length) return null;

  const rowSettings = (row?.row?.content as RowElementModel)?.properties;

  return (
    <div
      className={cn('row', rowSettings?.fullWidth ? 'w-full' : 'container')}
      style={
        rowSettings?.backgroundColor
          ? { backgroundColor: rowSettings?.backgroundColor as unknown as string }
          : undefined
      }
    >
      {row.components.map((component, index) => {
        return (
          <Step
            key={index}
            item={component}
            index={index}
            context={context}
            extraProps={{ rowIndex: rowIndex }}
          />
        );
      })}
    </div>
  );
}
